module.exports = __webpack_public_path__ + "static/tdem-ce5dd4de6cbb57f6439f2326857c3647.png";